import { AnyAction, isType } from 'typescript-fsa';
import { SqlStatistics } from '../../../services/betting';
import { setSqlStatisticsAction, setSqlStatisticsServerAvailable } from './actions';

export interface SqlServerState {
    stats: SqlStatistics[];
    serverAvailable: boolean;
}

export interface SqlStatisticsState {
    [serverName: string]: SqlServerState;
}

export const initialSqlStatisticsState: SqlStatisticsState = {};

export function sqlStatisticsReducer(state: SqlStatisticsState = initialSqlStatisticsState, action: AnyAction) {

    if (isType(action, setSqlStatisticsAction)) {
        let serverState: SqlServerState = Object.assign({}, state[action.payload.serverName], {
            stats: action.payload.stats
        });
        return Object.assign({}, state, { [action.payload.serverName]: serverState });
        
    } else if (isType(action, setSqlStatisticsServerAvailable)) {
        let serverState: SqlServerState = Object.assign({}, state[action.payload.serverName], {
            serverAvailable: action.payload.available
        });
        return Object.assign({}, state, { [action.payload.serverName]: serverState });
    }
    return state;

}